export default function faqAccordion () {
  const toggleEls = document.querySelectorAll('.page__faq__toggle')
  for (let i = 0; i < toggleEls.length; i++) {
    (function (el) {
      el.addEventListener('click', function (ev) {
        ev.preventDefault()
        el.parentNode.classList.toggle('page__faqs__item--expanded')
      })
    })(toggleEls[i])
  }
  const showMoreButtons = document.querySelectorAll('.page__faqs__action')
  for (let i = 0; i < showMoreButtons.length; i++) {
    (function (buttonEl) {
      const container = buttonEl.parentNode.parentNode
      const additionalFaqs = container.querySelectorAll('.page__faqs__item--additional')
      let showingMore = false

      buttonEl.addEventListener('click', function (ev) {
        ev.preventDefault()
        if (showingMore) {
          for (let j = 0; j < additionalFaqs.length; j++) {
            additionalFaqs[j].classList.add('page__faqs__item--hidden')
          }
          buttonEl.innerText = 'View ' + buttonEl.dataset.additionalCount + ' more +'
          showingMore = false
        } else {
          for (let j = 0; j < additionalFaqs.length; j++) {
            additionalFaqs[j].classList.remove('page__faqs__item--hidden')
          }
          buttonEl.innerText = 'View ' + buttonEl.dataset.additionalCount + ' fewer -'
          showingMore = true
        }
      })
    })(showMoreButtons[i])
  }
}
